import { render } from "./AnsComparePart.vue?vue&type=template&id=69466413&scoped=true"
import script from "./AnsComparePart.vue?vue&type=script&lang=js"
export * from "./AnsComparePart.vue?vue&type=script&lang=js"

import "./AnsComparePart.vue?vue&type=style&index=0&id=69466413&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69466413"]])

export default __exports__